import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpClient } from '@angular/common/http';
import { MenuItemPreProcessor } from '../cashier/menu-item-pre-processor-helper.service';
import { Observable, map, catchError, of, shareReplay } from 'rxjs';
import { MenuOptionModel } from 'src/app/interfaces/sidemenu-interface';

@Injectable({ providedIn: 'root' })
export class SidemenuService {
  private cache$?: Observable<MenuOptionModel[]>;

  constructor(
    private config: ConfigService,
    private http: HttpClient,
    private menuItemPreProcessor: MenuItemPreProcessor
  ) { }

  getSidemenuData(): Observable<MenuOptionModel[]> {
    if (!this.cache$) {
      const rawConfig = this.config.getConfig().SITE_MENU_FILE;
      let parsedConfig: any;

      try {
        parsedConfig = JSON.parse(rawConfig);
      } catch {
        parsedConfig = rawConfig;
      }

      const menuUrl = this.config.loadCDNAsset(parsedConfig);

      this.cache$ = this.http.get<MenuOptionModel[]>(menuUrl).pipe(
        map((menuItems) =>
          menuItems.map((item) => {
            this.menuItemPreProcessor.menuItemPreProcessing(item);
            return item;
          })
        ),
        shareReplay(1),
        catchError((err) => {
          console.error('Failed to load menu', err);
          return of([]);
        })
      );
    }

    return this.cache$;
  }
}
